/**
 * Redux Store Configuration
 *
 * Central store for the entire Beacon application.
 * All slice reducers are registered here.
 */
import { configureStore } from '@reduxjs/toolkit';
import envReducer from './slices/env/envSlice';
import paymentReducer from './slices/payment/paymentSlice';
import fileReducer from './slices/file/fileSlice';
import executionReducer from './slices/execution/executionSlice';
import notificationReducer from './slices/notifications/notificationSlice';

export const store = configureStore({
  reducer: {
    env: envReducer,
    payment: paymentReducer,
    file: fileReducer,
    execution: executionReducer,
    notifications: notificationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
